import React from 'react'
import styles from './AiSearch.module.css'

const privacyPolicyUrl =
  'https://www.paypal.com/us/legalhub/privacy-full?_ga=1.252195081.1872382664.1682435374'

const PrivacyPolicy = (
  <div className={styles.caption_privacy_policy}>
    Any information you provide is processed in accordance with our{' '}
    <a
      href={privacyPolicyUrl}
      className={styles.link_privacy_policy}
      target="_blank"
      rel="noreferrer"
    >
      privacy policy
    </a>
    .
  </div>
)

export default PrivacyPolicy
